import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { sessionsClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation RemovePublicTokens($ids: [Int]) {
    removePublicTokens(ids: $ids)
  }
`

export const useRemoveWebhook = () => {
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['PublicTokens'], client: sessionsClient })
  const notify = useNotification()
  const modal = useAlert()
  const { t } = useTranslation('common')

  const handleRequest = ids => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { ids } }).then(resp => {
      if (!!resp.errors) notify.error({ title: t('errorDelete') })
    })
  }

  return [handleRequest, state]
}
